// tslint:disable:component-selector
import {
  Component,
  Input,
  ContentChildren,
  QueryList,
  OnInit,
  AfterContentInit,
  AfterViewInit,
  ElementRef,
  Renderer2,
  ViewChild,
  OnDestroy
} from '@angular/core';
import {
  animate,
  AnimationBuilder,
  AnimationFactory,
  AnimationPlayer,
  style
} from '@angular/animations';
import { Guid } from '../../../../core/common/guid';
import { PageSet } from '../../../../core/common/pageset';
//
// Carousel Item
//
import { RtiCarouselItem } from './rti-carousel-item/rti-carousel-item';
import * as Library from '../../../../core/library/index';

@Component({
  selector: 'rti-carousel',
  templateUrl: './rti-carousel.html',
  styleUrls: ['./rti-carousel.scss']
})
export class RtiCarousel implements OnInit, AfterContentInit, AfterViewInit {
  @Input() hidden: boolean;
  // tslint:disable-next-line
  @Input('page-size') _pageSize: number;
  @Input() index: number;
  @Input() indicators: boolean;
  // TO show overlay on the next card in mobile devices
  @Input() showMobileOverlay: Boolean = false;

  //
  // Children Content
  //
  @ContentChildren(RtiCarouselItem) children: QueryList<RtiCarouselItem>;
  @ViewChild('mycarousel') private carousel: ElementRef;
  //
  // Public Variables
  //
  public uid: string;
  //
  // Private Variables
  //
  private _pageSet: PageSet;

  /**
   * onNav()
   * @param $event
   */
  public onNav($event: MouseEvent) {
    const target = $event.currentTarget['dataset']['toggle'];
    switch (target) {
      case 'left':
        this.prev($event);
        break;
      case 'right':
      default:
        this.next($event);
        break;
    }
  }

  /**
   * onSwipeLeft()
   * @param $event
   */
  public onSwipeLeft($event: MouseEvent) {
    this.next($event);
  }

  /**
   * onSwipeRight()
   * @param $event
   */
  public onSwipeRight($event: MouseEvent) {
    this.prev($event);
  }

  /**
   * onPage()
   * @param item
   */
  public onPage(item) {
    this._pageSet.indexId = item.id;
    this._setActivePage();
    this._drawPage(null);
  }

  /**
   * getPages()
   */
  public getPages() {
    if (Library.isDefined(this._pageSet)) {
      if (this._pageSet.hasPages()) {
        this.orderCarouselElements();
        return this._pageSet.pages();
      }
    }
  }

  /**
   * getPageSet()
   */
  public getPageSet() {
    return this._pageSet;
  }

  /**
   * next()
   */
  public next($event: MouseEvent) {
    this._pageSet.next();
    this._setActivePage();
    this._drawPage($event);
  }

  /**
   * prev()
   */
  public prev($event: MouseEvent) {
    this._pageSet.previous();
    this._setActivePage();
    this._drawPage($event);
  }

  /**
   * ngAfterContentInit()
   */
  ngAfterContentInit() {
  }

  ngAfterViewInit() {
    this.children.changes.subscribe(child => {
      this._pageSet = new PageSet({
        pageSize: this._pageSize,
        length: child.length,
        indexId: this.index
      });

      if (this._pageSet.hasPages()) {
        //
        // Set the Default Active Page
        //
        this._pageSet.pages()[0].active = true;
        this._pageSet.indexId = 1;
        this.orderCarouselElements();
      }
    });
  }

  ngOnInit() {
    //
    // Set the left position based on the page size.
    //
    //  this._render.setStyle(this.carousel.nativeElement, 'left', `-${100 / this._pageSize}%`);
  }

  private _setActivePage() {
    const active = this._pageSet.ActivePage();
    this._pageSet.pages().forEach(page => {
      page.active = active.id === page.id;
    });
  }

  /**
   * _drawPage()
   */
  private _drawPage(element: MouseEvent) {

    if (typeof element.stopPropagation === 'function') {
      element.preventDefault();
      element.stopPropagation();
    }

    const target = Library.hasOwnProperty(element, 'type') ? element.type : element.currentTarget['dataset']['toggle'];

    switch (target) {
      case 'swipeleft':
      case 'left':
        this.carousel.nativeElement.classList.add('is-set', 'is-reversing');
        break;
      case 'swiperight':
      case 'right':
      default:
        this.carousel.nativeElement.classList.remove('is-reversing');
        break;
    }
    //
    // Active Page
    //
    const activeIndexId = this._pageSet.indexId;
    //
    // Set the flex basis based on the page size.
    //
    // let orderId = 1;
    // let done = false;
    // let basis = 100 / this._pageSize;
    // while (!done) {
    //   let el = this.children['_results'][
    //     this._pageSet.ActivePage().range.start
    //   ]['el'];
    //   // this._render.setStyle(el.nativeElement, 'flex-basis', `${basis}%`);
    //  this._render.setStyle(el.nativeElement, 'order', `${orderId}`);
    //   this._pageSet.next();
    //   done = orderId === this.children.length;
    //   orderId++;
    // }
    this.orderCarouselElements();
    //
    // Rest to Active Page
    //
    this._pageSet.indexId = activeIndexId;
  }

  private orderCarouselElements() {
    //
    // Set the flex basis based on the page size.
    //
    let orderId = 1;
    let done = false;
    const basis = 100 / this._pageSize;
    while (!done) {
      const el = this.children['_results'][
        this._pageSet.ActivePage().range.start
      ]['el'];
      // this._render.setStyle(el.nativeElement, 'flex-basis', `${basis}%`);
      this._render.setStyle(el.nativeElement, 'order', `${orderId}`);
      if (orderId === 2 && this.showMobileOverlay === true) {
        this._render.addClass(el.nativeElement, 'dd-mobile-overlay');
      } else {
        this._render.removeClass(el.nativeElement, 'dd-mobile-overlay');
      }
      this._pageSet.next();
      done = orderId === this.children.length;
      orderId++;
    }
  }

  /**
   * constructor()
   */
  constructor(
    private _render: Renderer2,
    private animationBuilder: AnimationBuilder
  ) {
    this._pageSet = new PageSet({});
    this.hidden = false;
    this.indicators = true;
    this._pageSize = 1;
    this.index = 1;
    this.uid = Guid.CHAR();
  }
}
